import { RGB_CHANNEL } from './ColorPickerPopoverPreview.constants'

export function isRgbChannelR(channel) {
  return channel === RGB_CHANNEL.r
}

export function isRgbChannelG(channel) {
  return channel === RGB_CHANNEL.g
}

export function isRgbChannelB(channel) {
  return channel === RGB_CHANNEL.b
}
